import React from 'react';
import { Badge, Fab, Zoom } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from '@mui/icons-material/Close';

interface ChatBubbleProps {
  isOpen: boolean;
  unreadCount: number;
  onClick: () => void;
}

export const ChatBubble: React.FC<ChatBubbleProps> = ({ isOpen, unreadCount, onClick }) => {
  return (
    <Zoom in>
      <Fab
        color="primary"
        onClick={onClick}
        sx={{
          position: 'fixed',
          bottom: { xs: 24, md: 24 },
          right: { xs: 20, md: 40 },
          zIndex: 1400,
          width: 56,
          height: 56,
        }}
        aria-label="chat"
      >
        <Badge
          badgeContent={isOpen ? 0 : unreadCount}
          color="error"
          sx={{
            '& .MuiBadge-badge': {
              top: -4,
              right: -4,
            },
          }}
        >
          {isOpen ? <CloseIcon /> : <ChatIcon />}
        </Badge>
      </Fab>
    </Zoom>
  );
};
